import { render, staticRenderFns } from "./FinalReviewStepSummary.vue?vue&type=template&id=22aa16cc&"
import script from "./FinalReviewStepSummary.vue?vue&type=script&lang=js&"
export * from "./FinalReviewStepSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports